import React, { useEffect, useState} from "react";
import { Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchFilter from "../../components/common/SearchFilter";
import { useNavigate } from "react-router-dom";
import UserList from "../../components/UserList/UserList";
import { BasicLayout } from "../../layouts/BasicLayout";
import NotificationsListAPI from "../../utils/services/notifications.api";
import { getStorageValue } from "../../utils/helper";

const UsersListPage = () => {
  const navigate = useNavigate();
  const userId = getStorageValue("userId");
  
  const [isShowNotifications, setShowNotifications] = useState(false);
  const { checkUnreadNotifications } = NotificationsListAPI;
 
  const handleVisibilityChange = async () => {
    if (document.visibilityState === 'visible') {
      const checkDate = new Date()?.toISOString();
        const response = await checkUnreadNotifications(userId, checkDate);
        if(response?.data?.message) {
          localStorage.removeItem("isClicked");
          localStorage.setItem("isReload", response?.data?.message);
          localStorage.setItem("notifications", response?.data?.message);
          setShowNotifications(response?.data?.message);
        }
    } 
  };
  
  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <BasicLayout isShowNotifications={isShowNotifications}>
      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h5" fontWeight={500} fontSize={24}>
            Users
          </Typography>
          <Button
            style={{ textTransform: "none", backgroundColor: "#0C68F4"  }}
            variant="contained"
            size="medium"
            startIcon={<AddIcon />}
            onClick={() => {
              navigate("/create-package", {state: {backURL: "/users"}});
            }}
          >
            Create New
          </Button>
        </Box>
      </Box>

      <SearchFilter
        childComponent={<UserList />}
        filterCondition={true}
        placeholder={"Search by Username"}
        defaultValue= '0'
      />
    </BasicLayout>
  );
};

export default UsersListPage;
